<template>
  <div class="ds-custom-query-split" v-if="data">
    <div class="ds-custom-query-split-inner"></div>
  </div>
</template>
<script>
export default {
  name: "DsfCustomQuerySplit",
  inject: {
    $queryLogic:{
      default:null
    },
    $queryTree: {
      default: null
    },
    $queryNode: {
      default: null
    }
  },
  data() {
    return {};
  },
  props: {
    data: {
      type: Object,
      default() {
        return null;
      }
    },
    pos: {
      type: String,
      default: ""
    }
  },
  computed: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {
    this.initDrop();
  },
  beforeDestroy() {},
  destroyed() {},
  methods: {
    initDrop() {
      let _this = this;
      if (this.$el && this.$el.nodeType == 1) {
        $(this.$el).droppable({
          accept: function () {
            return true;
          },
          greedy: true,
          tolerance: "pointer",
          hoverClass: "ds-custom-query-split-hover",
          drop($evt, ui) {
            if (_this.pos) {
              let fromComponent = ui.draggable.get(0).__vue__;
              let fromData;
              //组件内部节点互相拖动
              if (_this.$queryTree.dragStart) {
                fromData = fromComponent.data;
              }
              //与外部节点拖动 
              else {
                fromData = _this.$queryTree.createItemData(fromComponent.data);
              }
              _this.dropToSplit(fromData, _this.data, _this.pos);
              _this.$queryTree.dropEnd()
            }
          }
        });
      }
    },
    dropToSplit(fromData, target, pos) {
      let oldItems = fromData?.parent?.items;
      if (oldItems) {
        dsf.array.remove(oldItems, fromData);
      }
      let items = target?.parent?.items;
      let index = _.findIndex(items, (it) => {
        return it == target;
      });
      if (index >= 0) {
        if (pos == "after") {
          index++;
        }
        items.splice(index, 0, fromData);
      }
      this.$queryTree.resetTree();
    }
  }
};
</script>